import { ForwardedRef, forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { RootComponent } from '../root-component';
import { Props } from './types';
import css from './style.module.css';

export const Layout = forwardRef(function VisuallyHidden<T>(
  { Component = 'span', baseClassName, ...props }: Props<T>,
  forwardedRef: ForwardedRef<T>
) {
  return (
    <RootComponent
      {...props}
      Component={Component}
      baseClassName={clsx(baseClassName, css.root, {
        [css.focusable]: Component === 'input',
      })}
      ref={forwardedRef}
    />
  );
});
